import useLanguageOptions from '@common/src/hooks/useLanguageOptions';
import PartyCreationFormInput from '@parties/src/features/creation/components/PartyCreationFormInput';
import { Select } from '@wegroup/design-system';
import { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../../../../../i18n';
import { Language } from '../../../../../../../types/Common';

interface Props {
  value?: Language;
  onChange?: (value: Language) => void;
}

const AdvisoryReportLanguagePicker: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const { userLang } = useLocale();

  const options = useLanguageOptions();

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value as Language;
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <PartyCreationFormInput label={t('ADVISORY-REPORT_LANGUAGE')}>
      <Select defaultValue={userLang} onChange={handleChange} value={value}>
        {options.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>
    </PartyCreationFormInput>
  );
};

export default AdvisoryReportLanguagePicker;
